export const ComponentsSelectionOptions = {
  CHOOSE_COMPONENTS: 'chooseComponents',
  USE_POLICY_DEFINED_COMPONENTS: 'usePolicyDefinedComponents',
};
